<template lang="pug">
  v-container(fluid)
    h2.text-center {{translations.title}}
    v-row.px-2.px-sm-10( justify="center")
      v-col(cols="12")
        v-expansion-panels
          v-expansion-panel
            v-expansion-panel-header {{ translations.filter.name }}
            v-expansion-panel-content
              v-container.pa-0(fluid)
                form
                  v-row
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseChipSelectField(:multiple="false", :items="operatorsListAll" v-model="userParams.operator", :label="translations.filter.operator")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(v-model="userParams.start", :label="translations.filter.start")
                    v-col.py-0(cols="12" sm="6" md="4")
                      BaseDatePicker(v-model="userParams.end", :label="translations.filter.end")
                    v-col.py-0.text-right(cols="12")
                      v-btn(@click="search" text color="primary")
                        v-icon.mr-2 mdi-magnify
                        | {{ translations.filter.send }}

      v-col.pb-0(cols="12")
        v-progress-linear(color="primary" :active="isLoading" indeterminate)
        v-simple-table
          template(default)
            thead
              tr
                th(v-for="header in headers") {{header.text}}
            tbody(ref="userData")
              tr(v-for="(item,i) in datos" :key="i")
                td
                  span.fantasy__block-width--8 {{ item.operator.n }}
                td {{ item.remote }}
                td
                  span.fantasy__block-width--8 {{ item.regDate }}
                td
                  span.fantasy__block-width--8 {{ item.lastTransaction }}
                td {{ item.currency }}
        v-divider
      v-col.pt-0(cols="12")
        v-row.justify-end
          v-col(cols="12" sm="12" md="6")
            pagination(@NextPage="nextPage()" @BackPage="backPage()" @changeLimit="changeLimit" :pagination="pagination")
</template>

<script>
  import Pagination from "@/components/pagination/pagination";
  export default {
    name: "UsersIndex",
    components: {
      Pagination,
    },
    data:() => ({
      userParams:{
        offset: 0,
        limit: 50,
        id: '',
        operator: null,
        start: '',
        end: ''
      },
      isLoading:false,
    }),
    computed:{
      translations(){
        return this.$t("views.usersIndex");
      },
      headers(){
        return [
          {
            text: this.translations.tableHeadText.operator,
            value: 'operator.n'
          },
          {
            text: this.translations.tableHeadText.username,
            value: 'remote'
          },
          {
            text: this.translations.tableHeadText.registrationDate,
            value: 'regDate'
          },
          {
            text: this.translations.tableHeadText.lastTransaction,
            value: 'lastTransaction'
          },
          {
            text: this.translations.tableHeadText.currency,
            value: 'currency'
          },
        ]
      },
      datos(){
        if(this.usersListAll.docs != undefined){
          const vm = this;
          return this.usersListAll.docs.map(user => {
            return {
              id: user._id,
              operator: user.b,
              remote: user.r,
              currency: user.c,
              regDate: vm.$moment(user.cat).format('DD/MM/YYYY HH:mm'),
              lastTransaction: vm.$moment(user.uat).format('DD/MM/YYYY HH:mm')
            }
          })
        }else{
          return [];
        }
      },
      pagination(){
        if(this.usersListAll.docs != undefined) {
          return {
            hasPrevPage: this.usersListAll.hasPrevPage,
            hasNextPage: this.usersListAll.hasNextPage,
            limit: this.usersListAll.limit,
            page: this.usersListAll.page,
            pageCounter: this.usersListAll.pagingCounter,
            totalPages: this.usersListAll.totalPages
          }
        }else{
          return {};
        }
      },
      operatorsListAll() {
        return this.$store.state.operators.map(operator => ({
          text:operator.n,
          value:operator._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      usersListAll() {
        return this.$store.state.users;
      },
    },
    watch: {
      usersListAll: function(val){
        if (val){
          this.isLoading = false;
          this.$refs.userData.style.display = "table-row-group";
        }
      },
    },
    created(){
      let userParams = {
          offset: 0,
          limit: 30,
          id: '',
          operator: ''
      };
      this.$store.dispatch('getUsers',userParams);
      this.$store.dispatch('getOperators');
    },
    methods:{
      viewInfo() {
        this.$router.push('/users/view');
      },
      nextPage() {
        let offset = this.userParams.offset + this.userParams.limit;

        this.userParams.offset = offset;

        this.search();
        this.TopscrollTo();
      },
      backPage() {
        let offset = this.userParams.offset - this.userParams.limit;

        this.userParams.offset = offset;

        this.search();
        this.TopscrollTo();
      },
      changeLimit(limit){
        this.userParams.limit = limit;
        this.search();
        this.TopscrollTo();
      },
      TopscrollTo() {
        if(window.scrollY!=0) {
          setTimeout(function() {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }, 100);
        }
      },
      search(){
        this.isLoading = true;
        this.$refs.userData.style.display = "none";

        let filterParams = {
          offset: this.userParams.offset,
          limit: this.userParams.limit,
          id: this.userParams.id,
          operator: this.userParams.operator != null ? this.userParams.operator.value : '',
          start: this.userParams.start,
          end: this.userParams.end,
        };
        this.$store.dispatch('getUsers', filterParams);
      },
    },
  }
</script>

<style lang="sass">
</style>